import { Suspense } from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import * as urls from 'routes/config';
import Spinner from 'components/Common/Spinner';

import BusinessProfileForm from 'containers/Business/Setting/BusinessProfile';
import Billing from 'containers/Business/Setting/Billing';
import TeamMembers from 'containers/Business/Setting/TeamMembers';
import TeamMemberForm from 'containers/Business/Setting/TeamMembers/components/TeamMemberForm';
import Operator from 'containers/Business/Setting/Operator';
import OperatorForm from 'containers/Business/Setting/Operator/Components/OperatorForm';
import KnowledgeBases from 'containers/Business/Setting/KnowledgeBase/KnowledgeBases';
import KnowledgeBaseForm from 'containers/Business/Setting/KnowledgeBase/components/KnowledgeBaseForm';
import KnowledgeBase from 'containers/Business/Setting/KnowledgeBase/KnowledgeBase';
import DataSet from 'containers/Business/Setting/DataSet';
import DataSetForm from 'containers/Business/Setting/DataSet/Components/DataSetForm';
import Chunks from 'containers/Business/Setting/Chunks';
import ChunkForm from 'containers/Business/Setting/Chunks/Components/ChunkForm';
import RetrievalTesting from 'containers/Business/Setting/RetrievalTesting';
import Integrations from 'containers/Business/Setting/Integrations';
import WebUrlForm from 'containers/Business/Setting/DataSet/Components/WebUrlForm';
import Workflows from 'containers/Business/Setting/Workflows';
import AddIntegrationForm from 'containers/Business/Setting/Integrations/Components/AddIntegrationForm';

export default function BusinessSettingRoutes() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route index element={<Navigate to={urls.business.profile} replace />} />
        <Route path={urls.business.profile} element={<BusinessProfileForm agencyView={false} />} />
        <Route path={urls.business.billing} element={<Billing />} />
        <Route path={urls.business.Workflow()} element={<Workflows />} />

        {/* Integration Routes */}
        <Route path={urls.business.integration()} element={<Integrations />}>
          <Route path='add' element={<AddIntegrationForm />} />
          <Route path=':integrationId' element={<AddIntegrationForm />} />
        </Route>

        {/* Team Routes */}
        <Route path={urls.business.team} element={<TeamMembers />}>
          <Route path='add' element={<TeamMemberForm />} />
          <Route path=':teamId' element={<TeamMemberForm />} />
        </Route>

        {/* Operator Routes */}
        <Route path={urls.business.operator} element={<Operator />}>
          <Route path='add' element={<OperatorForm />} />
          <Route path=':operatorId' element={<OperatorForm />} />
        </Route>

        {/* Knowledge Base Routes */}
        <Route path={urls.business.KnowledgeBases()} element={<KnowledgeBases />}>
          <Route path='add' element={<KnowledgeBaseForm />} />
          <Route path=':knowledgeBaseId/edit' element={<KnowledgeBaseForm />} />
          <Route path=':knowledgeBaseId/clone' element={<KnowledgeBaseForm />} />
        </Route>
        <Route path={urls.business.KnowledgeBase()} element={<KnowledgeBase />}>
          <Route index element={<Navigate to={urls.knowledgeBase.dataset} replace />} />
          <Route path={urls.knowledgeBase.dataset} element={<DataSet />}>
            <Route path='add' element={<DataSetForm />} />
            <Route path='add-website' element={<WebUrlForm />} />
            <Route path=':datasetId/edit' element={<DataSetForm />} />
            <Route path=':datasetId/edit-website' element={<WebUrlForm />} />
          </Route>
          <Route path={`dataset/${urls.knowledgeBase.chunks()}`} element={<Chunks />}>
            <Route path='add' element={<ChunkForm />} />
            <Route path=':chunkId/edit' element={<ChunkForm />} />
          </Route>
          <Route path={urls.knowledgeBase.retrievalTesting} element={<RetrievalTesting />} />
        </Route>

        {/* Fallback Route */}
        <Route path='*' element={<Navigate to='/404' replace />} />
      </Routes>
    </Suspense>
  );
}
